import React from 'react'
export const PageLoading = () => <div>Loading...</div>
